import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link, NavLink } from "react-router-dom";

function Navbar() {
  const [open, setOpen] = useState(false);

  const links = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Team", path: "/team" },
    { name: "Contact", path: "/contact" },
  ];

  const desktopLinkClass = ({ isActive }) =>
    `relative rounded-2xl px-3 py-2 text-sm font-bold transition lg:px-4 ${
      isActive
        ? "border border-cyan-400 bg-cyan-400/20 text-cyan-400 shadow-[0_0_18px_rgba(34,211,238,0.35)]"
        : "text-white hover:bg-cyan-400/10 hover:text-cyan-400"
    }`;

  const mobileLinkClass = ({ isActive }) =>
    `mb-2 block rounded-2xl px-4 py-3 font-bold transition ${
      isActive
        ? "border border-cyan-400 bg-cyan-400/20 text-cyan-400 shadow-[0_0_18px_rgba(34,211,238,0.35)]"
        : "text-white hover:bg-cyan-400/10 hover:text-cyan-400"
    }`;

  return (
    <nav className="fixed left-0 right-0 top-0 z-50 border-b border-cyan-400/20 bg-slate-900/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/" className="flex shrink-0 items-center">
          <img
            src="/logo3.png"
            alt="Eiffeltech Logo"
            className="h-14 w-auto object-contain sm:h-16 md:h-14 lg:h-16"
          />
        </Link>

        <div className="hidden items-center gap-2 md:flex lg:gap-3">
          {links.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              end={link.path === "/"}
              className={desktopLinkClass}
            >
              {link.name}
            </NavLink>
          ))}
        </div>

        <button
          onClick={() => setOpen(!open)}
          className="rounded-full border border-cyan-400/30 p-2 text-white transition hover:border-cyan-400 hover:text-cyan-400 md:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-cyan-400/20 bg-slate-950 px-4 py-4 md:hidden">
          {links.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              end={link.path === "/"}
              onClick={() => setOpen(false)}
              className={mobileLinkClass}
            >
              {link.name}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
}

export default Navbar;
